import { put, call, takeEvery, all } from 'redux-saga/effects'

import * as Actions from 'actions/prompt_history'
import * as AppActions from 'actions/app'
import * as Api from 'api/bff'
import { mapPromptHistoryEntries, normalizePrompt } from 'utils/prompt_history'

export function* fetchPromptHistory({ payload: { key, limit = 10 } }) {
  try {
    const { entries: remoteEntries = [] } = yield call(Api.fetchPromptHistory, key, limit)

    yield put(Actions.fetchPromptHistorySuccess({
      key,
      entries: mapPromptHistoryEntries(remoteEntries)
    }))
  } catch (error) {
    yield put(Actions.fetchPromptHistoryError({ key, error }))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* createPromptHistoryEntry({ payload: { key, prompt, limit = 10 } }) {
  const normalizedPrompt = normalizePrompt(prompt)

  if (!normalizedPrompt) {
    return
  }

  try {
    const { entry: remoteEntry } = yield call(Api.createPromptHistoryEntry, key, normalizedPrompt)
    const [entry] = mapPromptHistoryEntries(remoteEntry ? [remoteEntry] : [])

    if (entry) {
      yield put(Actions.createPromptHistoryEntrySuccess({ key, entry, limit }))
    }
  } catch (error) {
    yield put(Actions.createPromptHistoryEntryError({ key, error }))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* deletePromptHistoryEntry({ payload: { key, id } }) {
  try {
    yield call(Api.deletePromptHistoryEntry, id)
    yield put(Actions.deletePromptHistoryEntrySuccess({ key, id }))
  } catch (error) {
    yield put(Actions.deletePromptHistoryEntryError({ key, id, error }))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* clearPromptHistory({ payload: { key } }) {
  try {
    yield call(Api.clearPromptHistory, key)
    yield put(Actions.clearPromptHistorySuccess({ key }))
  } catch (error) {
    yield put(Actions.clearPromptHistoryError({ key, error }))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* watchFetchPromptHistory() {
  yield takeEvery(Actions.fetchPromptHistoryStart, fetchPromptHistory)
}

export function* watchCreatePromptHistoryEntry() {
  yield takeEvery(Actions.createPromptHistoryEntryStart, createPromptHistoryEntry)
}

export function* watchDeletePromptHistoryEntry() {
  yield takeEvery(Actions.deletePromptHistoryEntryStart, deletePromptHistoryEntry)
}

export function* watchClearPromptHistory() {
  yield takeEvery(Actions.clearPromptHistoryStart, clearPromptHistory)
}

export default function* promptHistorySaga() {
  yield all([
    watchFetchPromptHistory(),
    watchCreatePromptHistoryEntry(),
    watchDeletePromptHistoryEntry(),
    watchClearPromptHistory()
  ])
}
